module.exports = __webpack_public_path__ + "static/media/visa.f87e5345.svg";